import { MdEmail } from 'react-icons/md'
import { useTranslation } from "react-i18next";

import { FaTwitter, FaFacebook,  FaInstagram,  FaApple, FaGoogle } from 'react-icons/fa';


export const months = [
  { value: 'Jan', label: 'January' },
  { value: 'Feb', label: 'February' },
  { value: 'Mar', label: 'March' },
  { value: 'Apr', label: 'April' },
  { value: 'May', label: 'May' },
  { value: 'Jun', label: 'June' },
  { value: 'Jul', label: 'July' },
  { value: 'Aug', label: 'August' },
  { value: 'Sep', label: 'September' },
  { value: 'Oct', label: 'October' },
  { value: 'Nov', label: 'November' },
  { value: 'Dec', label: 'December' }
];

export const validationRules = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,

  password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};:'"\\|,.<>\/?]).{8,}$/,
  passwordMessage:
    "Password must contain uppercase and lowercase characters, numbers, special character and must be minimum 8 and maximum 16 characters long.",
  confirmPasswordMessage:
    "Confirm password must contain uppercase and lowercase characters, numbers, special character and must be minimum 8 and maximum 16 characters long.",
  newPasswordMessage:
    "New password must contain uppercase and lowercase characters, numbers, special character and must be minimum 8 and maximum 16 characters long.",
  characters: /^[a-zA-Z_ ]*$/,
  charactersMessage: "Only alphabets are allowed.",
  numbers: /^\d*$/,
};

export const formLengthValidation = {
  name: 16,
  InterestName: 150,
  InterestRejex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[#?!@$%^&*-]).{8,}$/,
  InterestValidation:
    "please enter name in uppercase, lowercase, and all special characters.",
};

export const inputFieldsLength = {
  socialMediaLinks: 100,
}

export const iconMapping = {
  adminEmail: <MdEmail className="absolute left-3 top-2.5 text-gray-500" />,
  twitterLink: <FaTwitter className="absolute left-12 top-2.5 text-gray-500" />,
  instagramLink: <FaInstagram className="absolute left-12 top-2.5 text-gray-500" />,
  facebookLink: <FaFacebook className="absolute left-12 top-2.5 text-gray-500" />,
  appleLink: <FaApple className="absolute left-12 top-2.5 text-gray-500" />,
  googleLink: <FaGoogle className="absolute left-12 top-2.5 text-gray-500" />,
};

const UseChange = ({ data }) => {
  let { t } = useTranslation();
  return t(data);
};

export const getLinkValidation = (fieldName) => ({
  required: `Please enter ${fieldName} link.`,
  pattern: {
    value: validationRules.url,
    message: "Invalid link.",
  },
  validate: {
    whiteSpace: (value) => (value.trim() ? true : <>{<UseChange data="WHITE_SPACES_NOT_ALLOWED" />}</>),
  },
});
